import { createContext, useContext } from "react";
import { Actions, Settings } from "./types";

export type SettingsContextType = [Settings, (action: Actions) => void];

export const SettingsContext = createContext<SettingsContextType | null>(null);

// Narrower alternative to useStore() for consumers that only need `settings`
// + dispatch — re-renders only when the settings slice changes, not on every
// auth/langs/references update. Backed by the same StoreProvider reducer.
export const useSettings = (): SettingsContextType => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within StoreProvider");
  }
  return context;
};
